import React, { useState } from 'react';
import { Form, Nav, Accordion, Button } from 'react-bootstrap';

const NotificationToggle = ({ title, description, id, checked, onChange, disabled }) => (
  <div className="d-flex justify-content-between align-items-center mb-3">
    <span className="text-secondary">{description}</span>
    <Form.Check
      type="switch"
      id={id}
      className="m-0"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);

export function NotificationSettings() {
  const [activeTab, setActiveTab] = useState('preferences');
  const [preferences, setPreferences] = useState({
    enableNotifications: true,
    mentions: true,
    passwordChange: true,
    activityReply: true,
    groupUpdates: true,
    groupPromotion: true,
    groupInvites: true,
  });

  const handleToggle = (key) => {
    setPreferences((prevState) => {
      const newState = { ...prevState, [key]: !prevState[key] };
      if (key === 'enableNotifications' && !newState.enableNotifications) {
        // Turn off all preferences when "Enable Notifications" is off
        Object.keys(newState).forEach((pref) => {
          if (pref !== 'enableNotifications') newState[pref] = false;
        });
      }
      return newState;
    });
  };

  const renderPreferences = () => (
    <>
      <p className="text-muted mb-4">Choose which notifications to receive by email.</p>

      <Form>
        <div className="bg-light rounded p-3 mb-3 d-flex justify-content-between align-items-center">
          <span className="fw-medium">Enable Notifications</span>
          <Form.Check
            type="switch"
            id="enable-notifications"
            className="m-0"
            checked={preferences.enableNotifications}
            onChange={() => handleToggle('enableNotifications')}
          />
        </div>

        <div className="border rounded p-3 mb-3">
          <h6 className="text-muted mb-3">MENTIONS</h6>
          <NotificationToggle
            description='A member mentions you using "@Rahul"'
            id="mentions"
            checked={preferences.mentions}
            onChange={() => handleToggle('mentions')}
            disabled={!preferences.enableNotifications}
          />
        </div>

        <div className="border rounded p-3 mb-3">
          <h6 className="text-muted mb-3">ACCOUNT SETTINGS</h6>
          <NotificationToggle
            description="Your password is changed"
            id="password-change"
            checked={preferences.passwordChange}
            onChange={() => handleToggle('passwordChange')}
            disabled={!preferences.enableNotifications}
          />
        </div>

        <div className="border rounded p-3 mb-3">
          <h6 className="text-muted mb-3">ACTIVITY FEEDS</h6>
          <NotificationToggle
            description="A member replies to your post or comment"
            id="activity-reply"
            checked={preferences.activityReply}
            onChange={() => handleToggle('activityReply')}
            disabled={!preferences.enableNotifications}
          />
        </div>

        <div className="border rounded p-3">
          <h6 className="text-muted mb-3">SOCIAL GROUPS</h6>
          <NotificationToggle
            description="The details of a group you manage are updated"
            id="group-updates"
            checked={preferences.groupUpdates}
            onChange={() => handleToggle('groupUpdates')}
            disabled={!preferences.enableNotifications}
          />
          <NotificationToggle
            description="You're promoted in a group"
            id="group-promotion"
            checked={preferences.groupPromotion}
            onChange={() => handleToggle('groupPromotion')}
            disabled={!preferences.enableNotifications}
          />
          <NotificationToggle
            description="You receive a new invite to join a group"
            id="group-invites"
            checked={preferences.groupInvites}
            onChange={() => handleToggle('groupInvites')}
            disabled={!preferences.enableNotifications}
          />
        </div>

        <Button variant="primary" size="lg" className="px-4 d-block mx-auto mt-4">
          Save Changes
        </Button>
      </Form>
    </>
  );

  const renderSubscriptions = () => (
    <div className="mt-4">
      <Accordion>
        {['Groups', 'Forums', 'Discussions'].map((category, index) => (
          <Accordion.Item eventKey={index.toString()} className="border rounded mb-3" key={category}>
            <Accordion.Header className="d-flex align-items-center">
              <span className="fw-bold">{category}</span>
            </Accordion.Header>
            <Accordion.Body className="text-muted">
              You are not currently subscribed to any {category.toLowerCase()}.
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );

  return (
    <div>
      <h2 className="h3 mb-4">Notification Settings</h2>

      <Nav variant="tabs" className="mb-4">
        <Nav.Item>
          <Nav.Link
            active={activeTab === 'preferences'}
            onClick={() => setActiveTab('preferences')}
            className="border-0"
          >
            Preferences
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            active={activeTab === 'subscriptions'}
            onClick={() => setActiveTab('subscriptions')}
            className="border-0"
          >
            Subscriptions
          </Nav.Link>
        </Nav.Item>
      </Nav>

      {activeTab === 'preferences' ? renderPreferences() : renderSubscriptions()}
    </div>
  );
}
